import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { getReviewGroupValuesRpc, getStatsRpc, searchReviewsRpc } from 'academy-service-client/ecosystem-service-v1/operations';
import { rpcClient } from '../../../client';
const GET_RATINGS_TAGS = registerQuery({
  fieldName: 'ratingsTags',
  args: [],
  fetcher() {
    return rpcClient.call(getReviewGroupValuesRpc, {});
  }
});
const GET_RATINGS_STATS = registerQuery({
  fieldName: 'ratingsStats',
  args: ['entityId', 'reviewType', 'offeringId', 'profileId'],
  fetcher(queryParams) {
    return rpcClient.call(getStatsRpc, {
      data: queryParams
    });
  }
});
const POST_REVIEWS_SEARCH = registerQuery({
  fieldName: 'reviewsSearch',
  args: ['entityId', 'limit', 'offset', 'reviewTypes', 'reviewerPortalId', 'reviewerUserId', 'sortFields'],
  fetcher(params) {
    return rpcClient.call(searchReviewsRpc, {
      data: params
    });
  }
});
export const useGetReviewTags = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_RATINGS_TAGS);
  return {
    ratingsTags: data,
    loading,
    error
  };
};
export const useGetReviewStats = options => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_RATINGS_STATS, Object.assign({}, options));
  return {
    ratingsStats: data,
    loading,
    error,
    refetchRatings: refetch
  };
};
export const useSearchReviews = (data, options) => {
  const {
    data: searchReview,
    loading,
    error,
    refetch: refetchSearchReview
  } = useQuery(POST_REVIEWS_SEARCH, Object.assign({
    variables: data,
    skip: !data.reviewerUserId || !data.reviewerPortalId || !data.entityId
  }, options));
  return {
    searchReview,
    loading,
    error,
    refetchSearchReview
  };
};